import styled from 'styled-components';

export const NotificationBaseWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
  margin-top: 4px;
  .fui-MessageBar {
    margin: 4px;
    border: none;
  }
`;

export const NotificationItemWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
  background: rgb(243, 242, 241);
  overflow-x: hidden;
  .icon-cancel {
    display: flex;
    justify-content: end;
    padding-right: 4px;
    padding-top: 4px;
    cursor: pointer;
  }
`;

export const NotificationContentItemWrapper = styled.div<{ $theme?: string }>`
  width: 100%;
  padding-left: 8px;
  padding-right: 8px;
`;